import { Injectable } from '@angular/core';
import { UrlService } from '../../websiteCMS/services/url.service';
import {
  Appointment,
  Contact,
  EnquiryForm,
  IResponseContactForm,
  IResponseEnquiryForm,
  IResponseSupportTicket,
  IStatushelpSupprtAction,
  sendOtp,
  sendOtpRes,
  verifyOtp,
  verifyOtpres,
} from './contact';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends UrlService {
  constructor(private http: HttpClient) {
    super();
  }
  submitContactForm(payload: Contact) {
    return this.http.post<Contact>(`${this.ContactForm}`, payload, {
      observe: 'response',
    });
  }
  submitenquiryForm(payload: EnquiryForm) {
    return this.http.post<EnquiryForm>(`${this.EnquiryForm}`, payload, {
      observe: 'response',
    });
  }
  getcontactForm(
    limit: number,
    page: number,
    filter: string = '',
  ): Observable<HttpResponse<IResponseContactForm>> {
    return this.http.get<IResponseContactForm>(
      this.getContactForm + `?limit=${limit}&page=${page}&${filter}`,
      {
        observe: 'response',
      },
    );
  }
  getenquiryForm(
    limit: number,
    page: number,
    filter: string = '',
  ): Observable<HttpResponse<IResponseEnquiryForm>> {
    return this.http.get<IResponseEnquiryForm>(
      this.getEnquiryForm + `?limit=${limit}&page=${page}&${filter}`,
      {
        observe: 'response',
      },
    );
  }
  getsupportForm(
    limit: number,
    page: number,
    filter: string = '',
  ): Observable<HttpResponse<IResponseSupportTicket>> {
    return this.http.get<IResponseSupportTicket>(
      this.getSupportForm + `?limit=${limit}&page=${page}&${filter}`,
      {
        observe: 'response',
      },
    );
  }
  contactStatusActions(
    payload: IStatushelpSupprtAction,
    userId: number,
  ): Observable<HttpResponse<IStatushelpSupprtAction>> {
    return this.http.patch<IStatushelpSupprtAction>(
      `${this.statusContactURL}/${userId}`,
      payload,
      {
        observe: 'response',
      },
    );
  }
  enquiryStatusActions(
    payload: IStatushelpSupprtAction,
    userId: number,
  ): Observable<HttpResponse<IStatushelpSupprtAction>> {
    return this.http.patch<IStatushelpSupprtAction>(
      `${this.statusEnquiryURL}/${userId}`,
      payload,
      {
        observe: 'response',
      },
    );
  }
  supportStatusActions(
    payload: IStatushelpSupprtAction,
    userId: number,
  ): Observable<HttpResponse<IStatushelpSupprtAction>> {
    return this.http.patch<IStatushelpSupprtAction>(
      `${this.statusSupportURL}/${userId}`,
      payload,
      {
        observe: 'response',
      },
    );
  }
  sendOtpForm(payload: sendOtp) {
    return this.http.post<sendOtpRes>(`${this.sendOtpURL}`, payload, {
      observe: 'response',
    });
  }
  verifyOtpForm(payload: verifyOtp) {
    return this.http.post<verifyOtpres>(`${this.verifyOtpURL}`, payload, {
      observe: 'response',
    });
  }
  appointmentForm(payload: Appointment, token: string) {
    const headers = {
      'x-appointment-token': token,
    };

    return this.http.post<Appointment>(`${this.appointmentURL}`, payload, {
      headers: headers,
      observe: 'response',
    });
  }
}
